export default __webpack_public_path__ + "static/media/AdCave_07.4050f3ea.png";